// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"3d5a356e","112":"3ea294d5","621":"ea5295a1","963":"9ed0e10d"}[chunkId] + ".chunk.js";
};